import axios from 'axios';

// create a new axios instance
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

export default instance
